import React from 'react';

const JS_Bootcamp = () => {
  return (
    <div >
      <h1>JS_Bootcamp</h1>
      <p>Placeholder component for: "JS Bootcamp"</p>
    </div>
  );
};

export default JS_Bootcamp;
